import React from 'react'
import Banner from '../components/Home/Banner'
import Product from '../components/Home/Product'
import Pic from '../components/Home/Pic'
import Service from '../components/Home/Service'
import Trusted from '../components/Home/Trusted'
import Flex from '../components/Home/Flex'
import Form from '../components/Home/Form'
function Home() {
  return (
    <div>
      <Banner/>
      <Product/>
      <Pic/>
      <Service/>
 <Trusted/> 
 <Flex/>
 <Form/>  
    </div>
  )
}

export default Home
